
setVisited();
// setContentPadding();
let pastOrder = checkPastOrder();
let pastOrderLink = document.querySelector('.past-order-link');
if (pastOrder && pastOrderLink) {
  pastOrderLink.classList.remove('hide');
}
if (pastOrderLink) {
  pastOrderLink.addEventListener('click', () => {
    populateOrderTable();
    showPastOrderPopup();
  });
}

document.body.addEventListener('click', event => {
  if (event.target.id == 'placeNewOrder') {
    resetCustomerForm();
  };

  // Close cart event
  if (event.target.classList.contains('mfp-container')) {
    document.querySelector('body').classList.remove('overlay');
  }
  if (event.target.classList.contains('mfp-close')) {
    document.querySelector('body').classList.remove('overlay');
  }
});

// window.addEventListener('resize', () => {
//   setContentPadding();
// });

let popup = document.querySelector('.popup');
if (popup && popup.classList.contains('show')) {
  document.querySelector('body').classList.add('has-popup');
}

let closeBtns = document.querySelectorAll('.popup .fa-times');
closeBtns.forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.currentTarget.closest('.popup').classList.remove('show');
    document.querySelector('body').classList.remove('has-popup');
  });
});

let icon = document.querySelector('.icon-container .icon');
  if (icon != null) {
    icon.addEventListener('click', () => {
    showSubscribePopup();
  });
}

let viewOrderPopupBtn = document.querySelector('.popup-cta-link');
viewOrderPopupBtn.addEventListener('click', () => {
  document.querySelector('body').classList.add('overlay');
});

// Email cookies
let subscribeBtns = document.querySelectorAll('.newsletter_email_box button[value=Subscribe]');
subscribeBtns.forEach(subscribeBtn => {
  subscribeBtn.addEventListener('click', (e) => {
    let form = e.currentTarget.closest('form');
    let emailField = form.querySelector('input[name="contact[email]"]');
    setLocalStorage('customerEmail', emailField.value);
  });
});

let placeOrderButton = document.querySelector('#continue');
if (placeOrderButton) {
  placeOrderButton.addEventListener('click', () => {
    showCustomerInfoPopup();
    fillFormFields();
  });
}


let submitOrderButton = document.querySelector('#customer-form button[value=submit]');
if (submitOrderButton) {
  submitOrderButton.addEventListener('click', (e) => {
    e.preventDefault();
    let validForm = validateCustomerForm();

    if (validForm) {
      storeCustomerData();
      let orderData = makeData(getCustomerData(), getOrderData());
      sendData(orderData);
    }
  });
}

function sendData (data) {
  let customerInfoContainer = document.querySelector('.customer-info-form-container');
  customerInfoContainer.querySelector('.sending-order-message-container').classList.remove('hide');
  customerInfoContainer.querySelector('h1').classList.add('hide');
  customerInfoContainer.querySelector('#customer-form').classList.add('hide');
  const url = `https://rocketfireworks.yswhosting.com/fasttrack.php`;
  const options = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(data)
  };


  fetch(url, options)
    .then(response => response.json())
    .then(response => {
      if (response.success) {
        // store order data
        storeOrderData(response.data.order_number);

        // display thank you message
        customerInfoContainer.querySelector('#orderNumber').innerHTML = response.data.order_number;
        customerInfoContainer.querySelector('.sending-order-message-container').classList.add('hide');
        document.querySelector('.customer-info').classList.remove('show');

        // display pickup message
        displayPickupMessage();

        // clear cart
        Shopify.clear((cart) => {
          Shopify.updateQuickCart(cart);
        });
      } else {
        customerInfoContainer.querySelector('.sending-order-message-container').classList.add('hide');
        document.querySelector('.customer-info').classList.remove('show');

        // display error message
        displayErrorMessage();
      }
      
    });
}

function makeData (customer, items, location = 'general') {
  return data = {
    'customer': customer,
    'order': {
      'items': items,
      'type': 'layby',
      'location': location,
      'tax_region': 'ON'
    }
  }
}

function getCustomerData () {
  let form = document.querySelector('#customer-form');
  let button = document.querySelector('#customer-form button[value=submit]');
  let formData = new FormData(form, button);

  return {
    'first_name': formData.get('firstName'),
    'last_name': formData.get('lastName'),
    'email': formData.get('email'),
    'phone': formData.get('phone')
  }
}

function getOrderData () {
  let form = document.querySelector('#cart');
  let items = [];
  Array.from(form.elements).forEach((row) => {
    if (row.classList.contains('quantity__input')) {
      let item = {};
      let productRow = row.closest('.cart-item');
      item.sku = productRow.dataset.sku;
      item.quantity = row.defaultValue;
      items.push(item);
    }
  });
  return items;
}

// Validation
function validateCustomerForm () {
  let form = document.querySelector('#customer-form');
  let button = document.querySelector('#customer-form button[value=submit]');
  let formData = new FormData(form, button);
  let formErrorOutput = document.querySelector('#customer-form .form-error');
  if (isEmpty(formData.get('firstName'))) {
    formErrorOutput.innerHTML = 'Please enter your first name.';
    return false;
  } else if (isEmpty(formData.get('lastName'))) {
    formErrorOutput.innerHTML = 'Please enter your last name.';
    return false;
  } else if (isEmpty(formData.get('email'))) {
    formErrorOutput.innerHTML = 'Please enter your email.';
    return false;
  } else if (isEmpty(formData.get('phone'))) {
    formErrorOutput.innerHTML = 'Please enter your phone number.';
    return false;
  }
  return true;
}

function isEmpty (value) {
  if (value === null || value === "" || Number.isNaN(value)) {
    return true;
  }
  return false;
}

// cookies
function setCookie (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie (cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setVisited () {
  let visited = localStorage.getItem('visited');
  if (visited === null) {
    localStorage.setItem('visited', 'true');
    let icon = document.querySelector('.icon-container .icon');
      if (icon != null) {
        icon.addEventListener('click', () => {
        showSubscribePopup();
      });
    }
  }
}

function storeCustomerData () {
  let customerData = getCustomerData();
  setLocalStorage('customerEmail', customerData.email);
  setLocalStorage('customerFirstName', customerData.first_name);
  setLocalStorage('customerLastName', customerData.last_name);
  setLocalStorage('customerPhone', customerData.phone);
}

function storeOrderData (order_number) {
  let orderDataString = localStorage.getItem('orderData');
  let orderData;

  if (orderDataString !== null) {
    orderData = JSON.parse(orderDataString);
  } else {
    orderData = [];
  }

  let order = {
    number: order_number,
    date:  new Date()
  }
  orderData.unshift(order);
  localStorage.setItem('orderData', JSON.stringify(orderData));
}

function fillFormFields () {
  let customerEmail = localStorage.getItem('customerEmail');
  let customerFirstName = localStorage.getItem('customerFirstName');
  let customerLastName = localStorage.getItem('customerLastName');
  let customerPhone = localStorage.getItem('customerPhone');
  
  let form = document.querySelector('#customer-form');

  form.querySelector('input[name="email"').value = customerEmail;
  form.querySelector('input[name="firstName"').value = customerFirstName;
  form.querySelector('input[name="lastName"').value = customerLastName;
  form.querySelector('input[name="phone"').value = customerPhone;
}

function checkPastOrder () {
  let pastOrder = false;
  let orderDataString = localStorage.getItem('orderData');
  if (orderDataString !== null) {
    pastOrder = true;
  }
  return pastOrder;
}

function resetCustomerForm () {
  let customerInfoContainer = document.querySelector('.customer-info-form-container');
  customerInfoContainer.querySelector('h1').classList.remove('hide');
  customerInfoContainer.querySelector('#customer-form').classList.remove('hide');
  customerInfoContainer.querySelector('.confirm-order-message-container').classList.add('hide');
}

function populateOrderTable () {
  let orderDataString = localStorage.getItem('orderData');
  let orderData = JSON.parse(orderDataString);
  let row = '';
  orderData.forEach(order => {
    row += `
    <tr>
      <td>${new Date(order.date).toLocaleDateString()}</td>
      <td>#${order.number}</td>
    </tr>`;
  });

  document.querySelector('.order-table tbody').innerHTML = row;
}

function setLocalStorage (dataName, data) {
  let dataStored = localStorage.getItem(dataName);
  if (dataStored === null && data !== '') {
    localStorage.setItem(dataName, data);
  }
}

// pickup message
function displayPickupMessage () {
  let orderDataString = localStorage.getItem('orderData');
  let orderData = JSON.parse(orderDataString);
  let message = `
  <div>
    <h1 class="message-heading"><span><i class="fa fa-check-circle"></i>Thank you</span>for your order!</h1>
    <h2>Please go to the checkout counter for payment and pick up.</h2>
    <p class="order-number-label">Your Order Number is:</p>
    <p class="order-number message-heading">#${orderData[0].number}</p>
    <a href="/pages/fasttrack" id="placeNewOrder" class='btn_c'>Place another order</a>
  </div>`;
  document.querySelector('.pickup-message').innerHTML = message;
  document.querySelector('.pickup-message').classList.remove('hide');
  document.querySelector('.cart__items-wrapper').classList.add('hide');
  document.querySelector('.cart__footer-wrapper').classList.add('hide');
}

// error message
function displayErrorMessage () {
  let orderDataString = localStorage.getItem('orderData');
  let orderData = JSON.parse(orderDataString);
  let message = `
  <div>
    <h2>There was a problem sending your order</h2>
    <h2>Please go to the counter for assistance.</h2>
  </div>`;
  document.querySelector('.pickup-message').innerHTML = message;
  document.querySelector('.pickup-message').classList.remove('hide');
}

function hidePickupMessage () {
  document.querySelector('.pickup-message').classList.add('hide');
  document.querySelector('.cart__items-wrapper').classList.remove('hide');
  document.querySelector('.cart__footer-wrapper').classList.remove('hide');
}

// show popup
function showSubscribePopup () {
  showPopup(document.querySelector('.subscribe-form'));
}

function showCustomerInfoPopup () {
  showPopup(document.querySelector('.customer-info'));
}

function showPastOrderPopup () {
  showPopup(document.querySelector('.past-order'));
}

function showPopup (popup) {
  popup.classList.add('show');
  document.querySelector('body').classList.add('has-popup');
}

// hide popup
function hideSubscribePopup () {
  hidePopup(document.querySelector('.subscribe-form'));
}

function hideCustomerInfoPopup () {
  hidePopup(document.querySelector('.customer-info'));
}

function hidePastOrderPopup () {
  hidePopup(document.querySelector('.past-order'));
}


function hidePopup (popup) {
  popup.classList.remove('show');
  document.querySelector('body').classList.remove('has-popup');
}

function closeCart () {
  document.querySelector('.mfp-close').click();
}

// set padding top 
function setContentPadding () {
  let content = document.querySelector('#content');
  let headerHeight = document.querySelector('#header').offsetHeight;
  content.style.paddingTop = `${headerHeight}px`;
}
